import { localTable } from "../services/LocalTable";

localTable.add({
    "one-day": "un giorno",
    "days": "giorni",
    "from-time": "da",
    "ago-time": "fa",
    "in-time": "tra",
    "hours": "ore",
    "in-few-time": "tra poco",
    "few-time-ago": "pochi istanti fa",
    "now-time": "ora",
    "one-hour": "un'ora",
    "load-more": "Carica altri {0}",
    "search-num-min": "Maggiore di {0}",
    "search-num-max": "Minore di {0}",
    "search-num-range": "Compreso tra {0} e {1}",
    "digit-a-number": "<scrivere un numero>",
    "search": "Ricerca",
    "select-date": "Seleziona data",
}, { lang: "IT" })

